'use client'

import { FC } from 'react'

import { useModalBaseProvider } from '@/contexts/modalBase/ModalBaseProvider'

import { Body, Footer, Header } from './components'
import styles from './styles.module.css'
import { ModalBaseProps, Subcomponents } from './types'

const ModalBase: FC<ModalBaseProps> & Subcomponents = ({
  isOverlayClickable,
  positionRight,
  positionBottom,
  positionTop,
  positionLeft,
  positionCenter,
  children,
  useContext,
  isOpenModal,
  setIsOpenModal,
  className = '',
}) => {
  const { modalOpen, setModalOpen } = useModalBaseProvider()

  function handleCloseModal() {
    if (useContext) {
      return setModalOpen(false)
    }

    setIsOpenModal && setIsOpenModal(false)
  }

  return (
    <div
      onClick={() => (isOverlayClickable ? handleCloseModal() : null)}
      className={`bg-black bg-opacity-50 inset-x-0 inset-y-0 absolute z-20 ${
        (useContext && modalOpen) || (!useContext && isOpenModal)
          ? 'flex'
          : 'hidden'
      }
    ${
      !positionRight &&
      !positionBottom &&
      !positionLeft &&
      !positionTop &&
      !positionCenter &&
      'items-center justify-center'
    }
    ${positionCenter && 'justify-center items-center'}
    `}
      id="modal-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`bg-white flex flex-col w-fit h-auto items-center absolute
        m-6 p-8 gap-8 z-20 rounded-2xl
        shadow-[0_2px_2px_0_rgba(0,0,0,0.25)]
        ${positionRight && 'right-0'}
        ${positionLeft && 'left-0'}
        ${positionTop && 'top-0'}
        ${positionBottom && 'bottom-0'}
        ${styles.modalContent}
        ${className}
        `}
      >
        <div className="w-full h-full gap-8 overflow-auto">
          <div className="flex flex-col gap-8">{children}</div>
        </div>
      </div>
    </div>
  )
}

ModalBase.Header = Header
ModalBase.Body = Body
ModalBase.Footer = Footer

export default ModalBase
